import { GAME_W, COPTER_X_RATIO } from "./data";

export const camera = {
  x: 0,

  reset(wx: number): void {
    this.x = (wx - GAME_W * COPTER_X_RATIO) | 0;
  },

  update(copterWx: number): void {
    this.x = (copterWx - GAME_W * COPTER_X_RATIO) | 0;
  },

  worldToScreenX(wx: number): number {
    return (wx - this.x) | 0;
  },

  screenToWorldX(sx: number): number {
    return sx + this.x;
  },
};
